export const getPrice = (pricePerItem, quantity) =>
  Number.parseFloat(pricePerItem * quantity).toFixed(2)
